import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

interface EmptyDataProps {
  height?: string;
  bgColor?: string;
}

const StyledEmptyData = styled("div")<EmptyDataProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 220px;
  padding: 20px;
  box-sizing: border-box;
  background-color: ${({ bgColor }) => bgColor ?? "transparent"};

  ${({ height }) => height && `height: ${height}`};
`;

const StyledEmptyDataContent = styled("div")<{ direction?: "row" | "column" }>`
  display: flex;
  flex-direction: ${({ direction }) => direction ?? "row"};
  gap: 24px;
  text-align: center;
  align-items: center;
  box-sizing: border-box;
`;

const StyledEmptyDataImgContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 70px;
  height: 70px;
`;

const StyledEmptyDataImg = styled("img")`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`;

const StyledEmptyDataText = styled(Typography)`
  color: ${({ theme }) => theme.palette.customGrey.dark};
  font-weight: 300;
`;

export {
  StyledEmptyData,
  StyledEmptyDataContent,
  StyledEmptyDataImgContainer,
  StyledEmptyDataImg,
  StyledEmptyDataText,
};
